'use es6'; // these params need to match the internal property names used in the report abuse form

const ABUSE_MEDIUM = 'abuse_medium=AbuseMediumContent';
const CONTENT_URL = `full_email_headers_or_content_url=${encodeURIComponent(window.location.href)}`;
const REPORT_ABUSE_AUTOFILL_PARAMS = `?${ABUSE_MEDIUM}&${CONTENT_URL}`;
const CMS_FREE_SIGNUP = '#';
const REPORT_ABUSE = `https://policy.hubspot.com/abuse-complaints${REPORT_ABUSE_AUTOFILL_PARAMS}`;
export const Links = {
  CMS_FREE_SIGNUP,
  REPORT_ABUSE
};